var _typeToFactoryMap;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { BLOCK } from '../const';
import buttons from './buttons';
import image from './image';
import footer from './footer';
import table from './table';
import separator from './separator';
import traffic from './traffic';
import universal from './universal';
import title from './title';
import container from './container';
import gallery from './gallery';
import tabs from './tabs';

var typeToFactoryMap = (_typeToFactoryMap = {}, _defineProperty(_typeToFactoryMap, BLOCK.buttons, buttons), _defineProperty(_typeToFactoryMap, BLOCK.image, image), _defineProperty(_typeToFactoryMap, BLOCK.footer, footer), _defineProperty(_typeToFactoryMap, BLOCK.table, table), _defineProperty(_typeToFactoryMap, BLOCK.separator, separator), _defineProperty(_typeToFactoryMap, BLOCK.traffic, traffic), _defineProperty(_typeToFactoryMap, BLOCK.universal, universal), _defineProperty(_typeToFactoryMap, BLOCK.title, title), _defineProperty(_typeToFactoryMap, BLOCK.container, container), _defineProperty(_typeToFactoryMap, BLOCK.gallery, gallery), _defineProperty(_typeToFactoryMap, BLOCK.tabs, tabs), _typeToFactoryMap);

/**
 * Фабрика блоков
 * @param  {Object} block
 * @return {Object}
 */
export default (function (block) {
    if (!block) {
        return null;
    }

    var factory = typeToFactoryMap[block.type];

    return factory ? factory(block) : null;
});